module.exports = __webpack_public_path__ + "static/img/AliExpress.99a5341.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/country/AliExpress.png
// module id = 35Bz
// module chunks = 1